<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Horários dos Professores
          <e-help-tooltip :text="$constants.tooltips.horariosInstrutores.horariosDosInstrutores" />
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text class="horarios-page__content">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="instrutorId"
                  :items="instrutores"
                  item-text="nome"
                  item-value="id"
                  label="Professor(a)"
                  class="input-professor"
                  outlined
                  dense
                  clearable
                />
              </v-col>
            </v-row>

            <horario-tabs v-model="tab" class="horarios-page__tabs" />

            <section v-if="tab === 0" class="horarios-page__section">
              <horario-dia-filtro
                v-model="dataSelecionada"
                class="horarios-page__filter"
                :disabled="!instrutorId"
                @buscar="buscarDia"
              />

              <horario-lista-agrupada :registros="registrosDia" />
            </section>

            <section v-if="tab === 1" class="horarios-page__section">
              <v-btn
                color="primary"
                class="horarios-page__action"
                :disabled="!instrutorId"
                @click="buscarUltimos10Dias"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
              <horario-lista-agrupada :registros="registrosUltimos10Dias" />
            </section>

            <section v-if="tab === 2" class="horarios-page__section">
              <horario-periodo-filtro
                class="horarios-page__filter"
                :disabled="!instrutorId"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <horario-lista-agrupada :registros="registrosPeriodo" />
            </section>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto"
      @close="fecharPdf"
    />
  </main-template>
</template>

<script>
import EModalEspelhoPontoPdf from "@/components/Instrutores/EModalEspelhoPontoPdf.vue";
import HorarioDiaFiltro from "@/components/Instrutores/HorarioDiaFiltro.vue";
import HorarioListaAgrupada from "@/components/Instrutores/HorarioListaAgrupada.vue";
import HorarioPeriodoFiltro from "@/components/Instrutores/HorarioPeriodoFiltro.vue";
import HorarioTabs from "@/components/Instrutores/HorarioTabs.vue";

export default {
  name: "InstrutoresHorariosAdminPage",
  components: {
    EModalEspelhoPontoPdf,
    HorarioDiaFiltro,
    HorarioListaAgrupada,
    HorarioPeriodoFiltro,
    HorarioTabs,
  },
  data() {
    return {
      tab: 0,
      instrutorId: null,
      instrutores: [],
      dataSelecionada: new Date().toISOString().slice(0, 10),
      registrosDia: null,
      registrosUltimos10Dias: null,
      registrosPeriodo: null,
      dialogPdf: false,
      pdf: null,
    };
  },
  watch: {
    instrutorId() {
      this.registrosDia = null;
      this.registrosUltimos10Dias = null;
      this.registrosPeriodo = null;
    },
  },
  mounted() {
    this.carregarInstrutores();
  },
  methods: {
    async carregarInstrutores() {
      try {
        this.instrutores = await this.$services.instrutorHorariosService.listarInstrutores();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async buscarDia() {
      if (!this.instrutorId) return;

      try {
        this.$loaderService.open("Carregando horários");
        this.registrosDia = await this.$services.instrutorHorariosService.adminHorariosDia({
          instrutor_id: this.instrutorId,
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarUltimos10Dias() {
      if (!this.instrutorId) return;

      try {
        this.$loaderService.open("Carregando horários");
        this.registrosUltimos10Dias =
          await this.$services.instrutorHorariosService.adminHorariosUltimos10Dias({
            instrutor_id: this.instrutorId,
          });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarPeriodo(form) {
      if (!this.instrutorId || !form.data_inicio || !form.data_fim) return;
      if (form.data_fim < form.data_inicio) return;

      try {
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.instrutorHorariosService.adminHorariosPeriodo({
          instrutor_id: this.instrutorId,
          ...form,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPdfPeriodo(form) {
      if (!this.instrutorId || !form.data_inicio || !form.data_fim) return;
      if (form.data_fim < form.data_inicio) return;

      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.instrutorHorariosService.adminHorariosPeriodoPdf({
          instrutor_id: this.instrutorId,
          ...form,
        });
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },
    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.horarios-page__content {
  padding: 24px;
}

.horarios-page__tabs {
  margin-top: 24px;
}

.horarios-page__section {
  margin-top: 20px;
}

.horarios-page__filter,
.horarios-page__action {
  margin-bottom: 20px;
}

.input-professor {
  font-size: 1rem;
}

@media (max-width: 959px) {
  .horarios-page__content {
    padding: 20px;
  }
}
</style>
